import { render } from "./CoverPage.vue?vue&type=template&id=8f442750&scoped=true"
import script from "./CoverPage.vue?vue&type=script&lang=js"
export * from "./CoverPage.vue?vue&type=script&lang=js"

import "./CoverPage.vue?vue&type=style&index=0&id=8f442750&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f442750"]])

export default __exports__